import { withStyles } from '@material-ui/core/styles'
import Card from '@material-ui/core/Card'

const styles = {
  root: {
    boxShadow: '0 4px 24px 1px rgba(0, 0, 0, 0.06)',
    borderRadius: 8,
    overflow: 'visible',
  }
}

export default withStyles(styles)(Card)
